import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; 
import { useFilter } from "../../hooks";

const ExportPdfPage = () => {
  const params = useParams();

  const navigate = useNavigate();

  const { searchParams } = useFilter();

  useEffect(() => {
    navigate(`/pdf-download`, {
      state: { ...params, searchParams: Object.fromEntries(searchParams) },
    });
  }, []);
  return <div>
    
  </div>;
};

export default ExportPdfPage;
